<template>
    <v-dialog v-model="dialog" width="600px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">{{ title }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4">
                <v-row>
                    <v-col cols="12">
                        The rating will be set to "Rejected"<br>
                        <br>
                        <!-- {{ actions }} -->
                        <br><br>
                        Add a reason for rejection, then click on "Reject"
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12"><v-text-field v-model="question.oavr_reject_oms" label="Reason of rejection" dense></v-text-field></v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-text>
            <v-card-actions>
                <btn_component data="" type="text" color="primary" text="Reject" tooltip="Actions will be executed" size="small" @actionClick="rejectAction" v-if="question.oavr_reject_oms!==''"/>
                <v-spacer></v-spacer>
                <btn_component data="" type="text" color="error" text="cancel" tooltip="Back to the question" size="small" @actionClick="cancelAction"/>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import btn_component from "@/components/ui/buttons/btn_component.vue";
    export default {
        components: {
            btn_component,
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                title: "",
                actions: "",
                question: {},
            }
        },
        methods: { 
            openDialog(question) {
                this.question = question;
                this.new_rating = this.question.oavr_rating;
                this.title = "Reject the answer from chatGPT";
                this.actions = "The question will be forwarded to belco, it needs to be ansered there.";
                this.dialog = true;
            },
            rejectAction() {
                this.$axios.post("ares/json/ares/task/customer_success/openai/questionRejectResult.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "questionRejectResult"
                    },
                    questionRejectResult: {
                        oavr_encrid: this.question.oavr_encrid,
                        oavr_reject_oms: this.question.oavr_reject_oms,
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error"
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.questionRejectResult.text,
                            color: res.data.questionRejectResult.color
                        });
                        this.$emit("updateAction", "rejected");
                        this.closeDialog();

                        this.closeDialog();
                    }
                });
            },
            cancelAction() {
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
        }
    }
</script>